import type { GraphQLError } from 'graphql';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import EditorPreferencesQuery, {
	type EditorPreferencesQuery$data,
	type EditorPreferencesQuery$variables,
} from './__generated__/EditorPreferencesQuery.graphql.ts';

export const preloadEditorPreferenceQuery = (): Promise<{
	data: EditorPreferencesQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> =>
	query<EditorPreferencesQuery$data, EditorPreferencesQuery$variables>({
		query: EditorPreferencesQuery,
	});
